module.exports = __webpack_public_path__ + "img/christopher-robin-logo.ce5793dc.png";